import { render } from "./SobreEmpresaLandingPage.vue?vue&type=template&id=45566e48&scoped=true"
import script from "./SobreEmpresaLandingPage.vue?vue&type=script&lang=js"
export * from "./SobreEmpresaLandingPage.vue?vue&type=script&lang=js"

import "./SobreEmpresaLandingPage.vue?vue&type=style&index=0&id=45566e48&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45566e48"]])

export default __exports__